module.exports = __webpack_public_path__ + "static/img/cert1.a92d0ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert1.png
// module id = 2Oa/
// module chunks = 52